export default "__VITE_ASSET__B4aI0vqf__"